import { render, staticRenderFns } from "./CountdownClock.vue?vue&type=template&id=ba01ba30"
import script from "./CountdownClock.vue?vue&type=script&lang=js"
export * from "./CountdownClock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports